import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (isDevMode()) {
        if (error.status === 429) {
          console.warn(
            `[HTTP 429] ${req.method} ${req.urlWithParams} — Rate limited. Please wait before retrying.`,
          );
        } else {
          console.error(`[HTTP ${error.status}] ${req.method} ${req.urlWithParams}`, error.message);
        }
      }
      return throwError(() => error);
    }),
  );
